import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppService} from './app.service';
import {ConfigService} from './config.service';
import {CookiesConsent} from '../_models/cookies-consent';
import {shareReplay} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {CookiesConsentPayload} from '../_models/cookies-consent-payload';
import {ForgeRockTokenService} from './forge-rock-token.service';

@Injectable({
  providedIn: 'root'
})
export class CookiesConsentService {
  private readonly apiUrl: string

  constructor(
    private http: HttpClient,
    private appService: AppService,
    private _configService: ConfigService,
    private _forgeRockTokenService: ForgeRockTokenService,
  ) {
    this.apiUrl = this._configService._config.apiUrlCookies
  }

  private get UsuarioLogado() {
    return this.appService.UsuarioLogado;
  }

  private get headers() {
    const accessToken = this._forgeRockTokenService.getAccessToken();
    const idToken = this._forgeRockTokenService.getIdToken();

    return {
      'Authorization': 'Bearer ' + accessToken,
      'X-ForgeRock-Token': idToken,
      'Consumer-Key': this._configService._config.consumerKeyCookies,
      'Content-Type': 'application/json',
      'Internal-Token': this.UsuarioLogado != null ? this.UsuarioLogado.tokenInterno : 'teste',
    }
  }

  getDataByUserId(userId: number, userEmail: string) {
    return this.http
      .get<CookiesConsent>(`${this.apiUrl}customers/consent`, {
        headers: this.headers,
        params: {
          customerCode: userId,
          customerEmail: userEmail,
        }
      })
  }

  postCookiesSettings(param: Partial<CookiesConsentPayload>) {
    return this.http.post(`${this.apiUrl}customers/save-consent`, param, {headers: this.headers, responseType: 'text'})
  }
}
